import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {withScriptjs, withGoogleMap, GoogleMap, Marker} from 'react-google-maps';
import {FormattedMessage} from 'react-intl';
import MessageDefinitions from './MessageDefinitions';
import Location from './Location';
import { LocationShape } from '@ignitesales/neuro-application/src/shapes';
import { igniteLocation } from './constants';
import getLogger from '@ignitesales/logger-es';

const logger = getLogger({component: 'ContactForm'});

const queryForLocations = (zipCode, onGeoLocationChange, onGeoLocationFailure) => {
  if (zipCode && zipCode.length === 5) {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({'address': zipCode}, (response, status) => {
      if (status.toLowerCase() === 'ok') {
        const lat = response[0].geometry.location.lat();
        const lng = response[0].geometry.location.lng();
        onGeoLocationChange({lat, lng});
      } else {
        logger.error('Unable to obtain location geography data for zip code', zipCode);
        onGeoLocationFailure();
      }
    });
  }
};

const setCenterAndZoom = (locations, mapRef) => {
  if (locations.length > 0) {
    const bounds = new window.google.maps.LatLngBounds();
    locations.forEach(location => bounds.extend(new window.google.maps.LatLng(location.lat, location.lng)));
    if(mapRef && mapRef.current) {
      mapRef.current.fitBounds(bounds);
    }
  }
};


const LocationsMap =  withScriptjs(withGoogleMap(props => {
  const {onClick, selectedLocation, locations, zipCode, onGeoLocationChange, onGeoLocationFailure } = props;
  const [center] = useState(igniteLocation);
  const mapRef = useRef(null);

  useEffect(() => {
    queryForLocations(zipCode, onGeoLocationChange, onGeoLocationFailure);
  }, [zipCode]);

  useEffect(() => {
    setCenterAndZoom(locations, mapRef);
  }, [locations]);

  const mapLocationListings = locations.map(item => {
    const isSelected = selectedLocation && selectedLocation.id === item.id;
    const listingClicked = () => {
      onClick(item);
    };

    return <Location key={item.id} location={item} onClick={listingClicked} selected={isSelected}/>;
  });

  const mapMarkers = locations.map(item => {
    const markerClicked = () => {
      onClick(item);
    };
    const opacity = selectedLocation && selectedLocation.id === item.id ? 1 : 0.55;

    return <Marker key={item.id} position={{lat: item.lat, lng: item.lng}} onClick={markerClicked} opacity={opacity}/>;
  });

  return (
    <div className="locationMap__content">
      <div className='locationMap__locations'>
        {mapLocationListings.length ? mapLocationListings : <FormattedMessage {...MessageDefinitions.appointmentNoLocations} />}
      </div>
      <GoogleMap
        ref={mapRef}
        defaultZoom={10}
        defaultCenter={center}>
        {mapMarkers}
      </GoogleMap>
    </div>
  );
}));

LocationsMap.propTypes = {
  onClick: PropTypes.func,
  selectedLocation: LocationShape,
  zipCode: PropTypes.string,
  onGeoLocationChange: PropTypes.func,
  onGeoLocationFailure: PropTypes.func,
  locations: PropTypes.arrayOf(LocationShape),
};

export default LocationsMap;
